module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mission-slot-registrations-table'), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotRegistrationSuppressNotifications),
      callback: function($$v) {
        _vm.missionSlotRegistrationSuppressNotifications = $$v
      },
      expression: "missionSlotRegistrationSuppressNotifications"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot registrations actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshMissionSlotRegistrations
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d0d3b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotRegistrations.vue
// module id = 502
// module chunks = 0